import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { RouterModule } from "@angular/router";
import { UrlModule, I18nModule, ConfigModule, CmsConfig } from "@spartacus/core";
import { FormErrorsModule, PasswordVisibilityToggleModule, GlobalMessageComponentModule } from "@spartacus/storefront";
import { UpdatePasswordComponent } from "./update-password.component";

@NgModule({
    declarations: [
      UpdatePasswordComponent
    ],
    providers: [
    ],
    imports: [
      CommonModule,
      FormsModule,
      ReactiveFormsModule,
      RouterModule,
      UrlModule,
      I18nModule,
      FormErrorsModule,
      PasswordVisibilityToggleModule,
      GlobalMessageComponentModule,
      MatDialogModule,
      MatButtonModule,
      MatIconModule,
    
    ],
  })
  export class updatePasswordModule { }
  